import { AsyncState, Updater, loadedAsyncState, loadingAsyncState } from 'widgets-for-react'
import { Alphabetized } from '../azNavigation/azNavigationUtils'
import { foldersApi } from './foldersApi'

export type FoldersState = {
  folders: AsyncState<Folders>
  folderFiltering: {
    searchValue?: string
    departmentOrCentrum?: string
  }
}

export type FolderItem = {
  kind: 'page' | 'pdf'
  url: string
  title: string
  introduction: string
  departments: string[]
  subdepartments: string[]
  centrums: string[]
  subcentrums: string[]
}

export type Folders = Alphabetized<FolderItem>

export const initialFoldersState = (
  departmentOrCentrum?: string,
  search?: string,
  previousState?: FoldersState
): FoldersState => ({
  folders: previousState ? previousState.folders : loadingAsyncState(() => foldersApi()),
  folderFiltering: {
    searchValue: search || undefined,
    departmentOrCentrum: departmentOrCentrum || undefined,
  },
})

export const FoldersStateUpdaters = {
  updateFoldersResultState:
    (updater: Updater<AsyncState<Folders>>) =>
    (currentState: FoldersState): FoldersState => ({
      ...currentState,
      folders: updater(currentState.folders),
    }),
}
